import React, { useState, useEffect, useRef, useCallback } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import Overlay from "./overlay/Overlay";

import DatabaseService from "../services/database.service.js";
import AuthService from "../services/auth.service";
import MQTTService from '../services/MQTTService';

import RaceMap from './race/RaceMap';

import RaceDataService from './race/RaceDataService';

import '../services/isMobile.js'

const BoardOverlay = (props) => {
  // State to hold the list of racers
  const [selectedCombinations, setSelectedCombinations] = useState([]);
  const [racersData, setRacersData] = useState([]);
  const [displayedRacerName1, setDisplayedRacerName1] = useState("");
  const [displayedRacerName2, setDisplayedRacerName2] = useState("");
  const [deviceCoordsHist, setDeviceCoordsHist] = useState({});
  const [circuit, setCircuit] = useState(1);
  const [raceDevicesFiltered, setRaceDevicesFiltered] = useState([]);
  const [overlayBackgroundColor, setOverlayBackgroundColor] = useState('rgba(0, 255, 0, 1)');
  const [lapCurrent, setLapCurrent] = useState(1);
  const [nbLapsOfRace, setNbLapsOfRace] = useState(1);
  const [fastestLap, setFastestLap] = useState(0);
  const [raceStopTimestamp, setRaceStopTimestamp] = useState(0);



  const [bms_bat_temp1, set_bms_bat_temp1] = useState(35);
  const [bms_bat_temp2, set_bms_bat_temp2] = useState(35);
  const [bms_int_temp1, set_bms_int_temp1] = useState(29);
  const [bms_int_temp2, set_bms_int_temp2] = useState(29);


  const mapRef = useRef(null);


  const handleDataUpdate = useCallback((updatedData) => {
    // Assuming 'updatedData' contains an object with 'currentData' and possibly 'deviceCoordsHist'
    if (updatedData.currentData) {
      // Update racersData with new currentData
      // Ensure to spread previous state to maintain immutability
      setRacersData(updatedData.currentData); // Assuming you want to replace the data

      // Extract and update temperature data if present and greater than 0
      const [firstRacerData] = updatedData.currentData;
      if (firstRacerData) {
        const { bms_bat_temp1, bms_bat_temp2, bms_int_temp1, bms_int_temp2, laps } = firstRacerData;
        if (bms_bat_temp1 > 0) set_bms_bat_temp1(bms_bat_temp1.toFixed(0));
        if (bms_bat_temp2 > 0) set_bms_bat_temp2(bms_bat_temp2.toFixed(0));
        if (bms_int_temp1 > 0) set_bms_int_temp1(bms_int_temp1.toFixed(0));
        if (bms_int_temp2 > 0) set_bms_int_temp2(bms_int_temp2.toFixed(0));

        // Update lap information based on the first racer's data
        if (laps) {
          const { lapCurrent: lapCurrent_p, nbLapsOfRace: nbLapsOfRace_p, lapTimes: lapTimes_p } = laps;
          setLapCurrent(lapCurrent_p);
          setNbLapsOfRace(nbLapsOfRace_p);

          const { raceStopTimestamp: raceStopTimestamp_p } = firstRacerData.laps || {};
          // console.log("raceStopTimestamp_p", raceStopTimestamp_p, "current raceStopTimestamp", raceStopTimestamp);

          // if (raceStopTimestamp_p !== undefined && raceStopTimestamp_p !== raceStopTimestamp) {
          setRaceStopTimestamp(raceStopTimestamp_p);
          // }

          if (lapTimes_p.length > 0 && raceStopTimestamp_p === 0) {
            const newFastestLap = Math.min(...lapTimes_p);
            //if (fastestLap !== newFastestLap)
            setFastestLap(newFastestLap);
          } else {
            setFastestLap(0);
          }
        }
      }


    }

    // Update device coordinates history if present
    if (updatedData.deviceCoordsHist) {
      setDeviceCoordsHist(updatedData.deviceCoordsHist);
    }
  }, [raceStopTimestamp, lapCurrent, nbLapsOfRace, fastestLap]); // Add necessary dependencies if they're used within the callback


  useEffect(() => {
    // Ensure racersParam is treated in uppercase
    const queryParams = new URLSearchParams(window.location.search);
    const racersParam = queryParams.get('racers').toLowerCase();
    const circuitParam = queryParams.get('circuit');
    const password = queryParams.get('pwd');
    const bkcolor = queryParams.get('bkcolor');

    console.log("BoardRace / loadRaceUsers / bkcolor", bkcolor);
    setOverlayBackgroundColor(bkcolor);

    localStorage.setItem("vloupk", password);
    AuthService.login("viewer@rage-mechanics.com", password).then(() => {

      DatabaseService.getPerfsRaceDevices().then((response) => {
        const raceUsers = response.data.filter((item) => (item.user_id !== "unknown@old.com"));

        console.log("BoardRace / loadRaceUsers / raceUsers", raceUsers);

        const newFiltered = raceUsers.map(device => ({ mac_custom: device.mac_custom.toLowerCase(), ble_name: device.ble_name }));
        console.log("BoardRace / loadRaceUsers / newFiltered", newFiltered);
        setRaceDevicesFiltered(newFiltered);

        if (circuitParam) {
          setCircuit(circuitParam);
        }

        if (racersParam) {
          const racersList = racersParam.toLowerCase().split(',');

          // remove racers not in the requested list
          const racersListWithDetails = raceUsers.filter(raceUser =>
            racersList.includes(raceUser.mac_custom.toLowerCase())
          );

          // Now find the first racer's details using the uppercase MAC address
          const firstRacerDetail = racersListWithDetails.find(raceUser => raceUser.mac_custom.toLowerCase() === racersList[0].toLowerCase());
          const racerNameSplit = firstRacerDetail?.race_username?.split(" ")
          if (racerNameSplit.length > 0)
            setDisplayedRacerName1(racerNameSplit[0]);
          if (racerNameSplit.length > 1)
            setDisplayedRacerName2(racerNameSplit[1]);
            if (racerNameSplit.length > 2)
            setDisplayedRacerName2(racerNameSplit[1] + ' ' + racerNameSplit[2]);
            if (racerNameSplit.length > 3)
            setDisplayedRacerName2(racerNameSplit[1] + ' ' + racerNameSplit[2] + ' ' + racerNameSplit[3]);


          setLapCurrent(1);
          setNbLapsOfRace(0);

          // console.log("BoardOverlay / firstRacerDetail.user_id?", firstRacerDetail);

          setSelectedCombinations(racersListWithDetails);

          RaceDataService.on('dataUpdated', handleDataUpdate);
          RaceDataService.setData(racersListWithDetails, raceDevicesFiltered, undefined);

          MQTTService.setUserAndPassword(localStorage.getItem("user"), localStorage.getItem("vloupk"), 0);
          MQTTService.connect();

          racersListWithDetails.forEach((racer) => {
            const topic = "raceteam/" + racer.race_team + "/device/" + racer.mac_custom.toUpperCase() + "/#";
            console.log("BoardOverlay / mqtt / topic", topic);
            MQTTService.subscribe(topic);
          });

        }

      })
    }
    )


    // Hide the navbar
    const navbar = document.querySelector('.navbar');
    if (navbar) {
      navbar.style.display = 'none';
    }
    const main = document.querySelector('.main');
    if (main) {
      main.style.backgroundColor = bkcolor;
    }
    const body = document.querySelector('.body');
    if (body) {
      body.style.lineHeight = 1;
    }
    const root = document.querySelector(':root');
    if (root) {
      root.style.backgroundColor = bkcolor;
      root.style.overflow = 'hidden';
    }


    return () => {
      console.log('Removing event listener...');
      RaceDataService.removeListener('dataUpdated', handleDataUpdate);
    };
  }, []);


  const selectedRacerDatas = (selectedCombinations.length > 0 && (racersData.length > 0))

  // console.log("nbLapsOfRace", nbLapsOfRace, "lapCurrent", lapCurrent, "fastestestLap", fastestLap, "raceStopTimestamp", raceStopTimestamp)
  // console.log("raceStopTimestamp", raceStopTimestamp)

  return (
    <div className='overlay-not-scrollable' id='overlay-not-scrollable' style={{
      backgroundColor: overlayBackgroundColor,
      display: 'flex', // Ensuring flex display
      flexDirection: 'column', // Stack children vertically
      justifyContent: 'flex-start', // Align children to the start vertically
      alignItems: 'flex-end' // Align children to the end (right) horizontally
    }}>
      {(selectedRacerDatas) ? (
        <>
          <Overlay
            throttle_percent={racersData[0].throttle_percent?.toFixed(0)}
            brake_percent={racersData[0].brake_percent?.toFixed(0)}
            BATTERIE_level={racersData[0].battery_level?.toFixed(0)}
            speed={racersData[0].speed.toFixed(0)}
            bms_bat_temp1={bms_bat_temp1}
            bms_bat_temp2={bms_bat_temp2}
            bms_int_temp1={bms_int_temp1}
            bms_int_temp2={bms_int_temp2}
            motor_temp={racersData[0].motor_temp.toFixed(0)}
            controller_temp={racersData[0].controller_temp?.toFixed(0)}
            voltage={racersData[0].voltage?.toFixed(0)}
            player_first_name={displayedRacerName1}
            player_surname={displayedRacerName2}
            lap_fastest={fastestLap}
            lap_current={lapCurrent}
            lap_total={(raceStopTimestamp == 0) ? nbLapsOfRace : 0}
          // lap_total={nbLapsOfRace}
          />

          <div className="row" style={{ width: '300px', height: '300px' }}>
            <RaceMap deviceCoordsHist={deviceCoordsHist} mapRef={mapRef} showTraj={false} trackUser={false} selectedCombinations={selectedCombinations} forcedSelectedCircuit={circuit} />
          </div>

        </>

      ) : (
        <p className="boldText">No racers specified.</p>
      )}
    </div>
  );

};

export default BoardOverlay;